// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetActivate2FA (params?: {}): Promise<Dict>;
    publicGetAuthenticate2FA (params?: {}): Promise<Dict>;
    publicGetAuthenticateUser (params?: {}): Promise<Dict>;
    publicGetEnableXP2FA (params?: {}): Promise<Dict>;
    publicGetGetL2Snapshot (params?: {}): Promise<List>;
    publicGetGetLevel1 (params?: {}): Promise<Dict>;
    publicGetGetValidate2FARequiredEndpoints (params?: {}): Promise<List>;
    publicGetLogOut (params?: {}): Promise<Dict>;
    publicGetGetTickerHistory (params?: {}): Promise<List>;
    publicGetGetProduct (params?: {}): Promise<Dict>;
    publicGetGetProducts (params?: {}): Promise<List>;
    publicGetGetInstrument (params?: {}): Promise<Dict>;
    publicGetGetInstruments (params?: {}): Promise<List>;
    publicGetGetEarliestTickTime (params?: {}): Promise<List>;
    publicGetPing (params?: {}): Promise<Dict>;
    publicGetAssets (params?: {}): Promise<List>;
    publicGetOrderbook (params?: {}): Promise<Dict>;
    publicGetTicker (params?: {}): Promise<Dict>;
    publicGetSummary (params?: {}): Promise<List>;
    publicGetTrades (params?: {}): Promise<List>;
    publicGetGetLastTrades (params?: {}): Promise<List>;
    publicGetConfirmWithdraw (params?: {}): Promise<Dict>;
    publicGetSubscribeLevel1 (params?: {}): Promise<Dict>;
    publicGetSubscribeLevel2 (params?: {}): Promise<List>;
    publicGetSubscribeTicker (params?: {}): Promise<List>;
    publicGetSubscribeTrades (params?: {}): Promise<List>;
    publicGetSubscribeBlockTrades (params?: {}): Promise<List>;
    publicGetUnsubscribeBlockTrades (params?: {}): Promise<Dict>;
    publicGetUnsubscribeLevel1 (params?: {}): Promise<Dict>;
    publicGetUnsubscribeLevel2 (params?: {}): Promise<Dict>;
    publicGetUnsubscribeTicker (params?: {}): Promise<Dict>;
    publicGetUnsubscribeTrades (params?: {}): Promise<Dict>;
    publicGetAuthenticate (params?: {}): Promise<Dict>;
    privateGetGetUserAccountInfos (params?: {}): Promise<List>;
    privateGetGetUserAccounts (params?: {}): Promise<List>;
    privateGetGetUserAffiliateCount (params?: {}): Promise<Dict>;
    privateGetGetUserAffiliateTag (params?: {}): Promise<List>;
    privateGetGetUserConfig (params?: {}): Promise<List>;
    privateGetGetAllUnredactedUserConfigsForUser (params?: {}): Promise<List>;
    privateGetGetUnredactedUserConfigByKey (params?: {}): Promise<List>;
    privateGetGetUserDevices (params?: {}): Promise<List>;
    privateGetGetUserReportTickets (params?: {}): Promise<List>;
    privateGetGetUserReportWriterResultRecords (params?: {}): Promise<List>;
    privateGetGetAccountInfo (params?: {}): Promise<Dict>;
    privateGetGetAccountPositions (params?: {}): Promise<Dict>;
    privateGetGetAllAccountConfigs (params?: {}): Promise<List>;
    privateGetGetTreasuryProductsForAccount (params?: {}): Promise<List>;
    privateGetGetAccountTrades (params?: {}): Promise<List>;
    privateGetGetAccountTransactions (params?: {}): Promise<List>;
    privateGetGetOpenTradeReports (params?: {}): Promise<List>;
    privateGetGetAllOpenTradeReports (params?: {}): Promise<List>;
    privateGetGetTradesHistory (params?: {}): Promise<List>;
    privateGetGetOpenOrders (params?: {}): Promise<List>;
    privateGetGetOpenQuotes (params?: {}): Promise<Dict>;
    privateGetGetOrderFee (params?: {}): Promise<Dict>;
    privateGetGetOrderHistory (params?: {}): Promise<List>;
    privateGetGetOrdersHistory (params?: {}): Promise<List>;
    privateGetGetOrderStatus (params?: {}): Promise<Dict>;
    privateGetGetOmsFeeTiers (params?: {}): Promise<List>;
    privateGetGetAccountDepositTransactions (params?: {}): Promise<List>;
    privateGetGetAccountWithdrawTransactions (params?: {}): Promise<List>;
    privateGetGetAllDepositRequestInfoTemplates (params?: {}): Promise<List>;
    privateGetGetDepositInfo (params?: {}): Promise<Dict>;
    privateGetGetDepositRequestInfoTemplate (params?: {}): Promise<Dict>;
    privateGetGetDeposits (params?: {}): Promise<List>;
    privateGetGetDepositTicket (params?: {}): Promise<Dict>;
    privateGetGetDepositTickets (params?: {}): Promise<List>;
    privateGetGetOMSWithdrawFees (params?: {}): Promise<List>;
    privateGetGetWithdrawFee (params?: {}): Promise<Dict>;
    privateGetGetWithdraws (params?: {}): Promise<List>;
    privateGetGetWithdrawTemplate (params?: {}): Promise<Dict>;
    privateGetGetWithdrawTemplateTypes (params?: {}): Promise<Dict>;
    privateGetGetWithdrawTicket (params?: {}): Promise<Dict>;
    privateGetGetWithdrawTicketAttachment (params?: {}): Promise<Dict>;
    privateGetGetWithdrawTickets (params?: {}): Promise<List>;
    privateGetGetDepositTicketAttachment (params?: {}): Promise<Dict>;
    privatePostAddUserAffiliateTag (params?: {}): Promise<Dict>;
    privatePostAddDepositTicketAttachment (params?: {}): Promise<Dict>;
    privatePostAddWithdrawTicketAttachment (params?: {}): Promise<Dict>;
    privatePostCancelUserReport (params?: {}): Promise<Dict>;
    privatePostRegisterNewDevice (params?: {}): Promise<Dict>;
    privatePostSubscribeAccountEvents (params?: {}): Promise<Dict>;
    privatePostUpdateUserAffiliateTag (params?: {}): Promise<Dict>;
    privatePostGenerateTradeActivityReport (params?: {}): Promise<Dict>;
    privatePostGenerateTransactionActivityReport (params?: {}): Promise<Dict>;
    privatePostGenerateTreasuryActivityReport (params?: {}): Promise<Dict>;
    privatePostScheduleTradeActivityReport (params?: {}): Promise<Dict>;
    privatePostScheduleTransactionActivityReport (params?: {}): Promise<Dict>;
    privatePostScheduleTreasuryActivityReport (params?: {}): Promise<Dict>;
    privatePostCancelAllOrders (params?: {}): Promise<Dict>;
    privatePostCancelOrder (params?: {}): Promise<Dict>;
    privatePostCancelQuote (params?: {}): Promise<Dict>;
    privatePostCancelReplaceOrder (params?: {}): Promise<Dict>;
    privatePostCreateQuote (params?: {}): Promise<Dict>;
    privatePostModifyOrder (params?: {}): Promise<Dict>;
    privatePostSendOrder (params?: {}): Promise<Dict>;
    privatePostSubmitBlockTrade (params?: {}): Promise<Dict>;
    privatePostUpdateQuote (params?: {}): Promise<Dict>;
    privatePostCancelWithdraw (params?: {}): Promise<Dict>;
    privatePostCreateDepositTicket (params?: {}): Promise<Dict>;
    privatePostCreateWithdrawTicket (params?: {}): Promise<Dict>;
    privatePostSubmitDepositTicketComment (params?: {}): Promise<Dict>;
    privatePostSubmitWithdrawTicketComment (params?: {}): Promise<Dict>;
    privatePostGetOrderHistoryByOrderId (params?: {}): Promise<List>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
